import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {PermissionsConverter} from "../../../../common/converter/permissions.converter";
import {InsoleMaterialSummaryModel} from "./insoleMaterialSummary.model";

@Injectable({
    providedIn: 'root'
})
export class InsoleMaterialSummaryConverter extends HttpModelConverter<InsoleMaterialSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): InsoleMaterialSummaryModel {
        return new InsoleMaterialSummaryModel();
    }

    protected enrichObject(result: InsoleMaterialSummaryModel, src: InsoleMaterialSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
    }
}
